<template>
	<div>
		<BaseAccordionCard :accordion_header="getStateWithParam('donate_a_tree_as_individ')" :toggable="false">
			<template v-slot:component>
				<!-- <PlantTreeContanct class="accordion-card-middle" /> -->
				<v-img :src="require('@/assets/img/plant-banner.png')" aspect-ratio="2"></v-img>
				<div class="contact-info-middle">
					<div style="margin-top: 15px;" class="contact-info-info contact-info-middle-bottom">
						<p>{{getStateWithParam('long_donate_tree_description')}}</p>
					</div>
					<div class="contact-info-info contact-info-middle-bottom">
						<div class="contact-info-icon-label" @click="openEmbedBrowser">
							<i class="material-icons">language</i>
							<span class="contact-info-middle-hour">Website</span>
						</div>
						<div
							class="contact-info-right contact-info-adres"
							@click="openEmbedBrowser"
						>{{getStateWithParam('contribute_plant')}}</div>
					</div>
				</div>
			</template>
		</BaseAccordionCard>
	</div>
</template>

<script>
import native_capacitor from "@/config/js_helper/native_capacitor";
//import PlantTreeContanct from "@/components/cards/PlantTreeContanct.vue";
import { APRTIRANA_URL } from "@/config/api/url/urls_in_app";
export default {
	name: "ContributePlant",
	mounted(){
		this.$nextTick(function () {
			this.$store.state.active_loader = false;
		})
	},
	methods: {
		getStateWithParam(param) {
			return this.$store.getters.getLanguageParameters(param);
		},
		openEmbedBrowser(){
			native_capacitor.openUrl(APRTIRANA_URL)
		}
	},
	data() {
		return {};
	}
};
</script>


<style scoped lang="scss" src="./ContributePlant.scss">
</style>

